var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px"}},[_c('a-alert',{attrs:{"type":"success","banner":"","closable":""}},[_c('p',{attrs:{"slot":"message"},slot:"message"},[_vm._t("message")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }